import { ref } from 'vue';

/**
 * Fetch wrapper with loading/error state for VulnFeedTable.
 */
export function useFetch({ fetchFn } = {}) {
    const items = ref([]);
    const loading = ref(false);
    const error = ref(null);

    /**
     * Execute a fetch with the given parameters.
     * Returns the full response object (including pagination metadata).
     */
    async function execute(params = {}) {
        loading.value = true;
        error.value = null;

        try {
            const response = await fetchFn(params);
            items.value = Array.isArray(response.items) ? response.items : [];
            return response;
        } catch (e) {
            error.value = e?.message || e?.data?.msg || 'Failed to load data';
            items.value = [];
            throw e;
        } finally {
            loading.value = false;
        }
    }

    return {
        items,
        loading,
        error,
        execute,
    };
}
